import { CommonModule } from '@angular/common'
import { Component, computed, OnDestroy, OnInit } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { Subject } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { TranslateModule } from '@ngx-translate/core'
import { OrderWizardItsMeLoginComponent } from './button/itsme-login-button.component'
import { OrderWizardService } from '../../_service/order-wizard.service'
import { ItsMeCustomerSummaryComponent } from './customer-summary/itsme-customer-summary.component'
import { CustomerDto } from '../../../model/customer.model'

@Component({
    selector: 'order-wizard-identification',
    imports: [CommonModule, ReactiveFormsModule, OrderWizardItsMeLoginComponent, TranslateModule, ItsMeCustomerSummaryComponent],
    templateUrl: './order-wizard-identification.component.html'
})
export class OrderWizardIdentificationComponent implements OnInit, OnDestroy {
    // form: FormGroup | null = null;
    private readonly destroy$ = new Subject<void>();
    step3  = computed(() => this._orderWizardService._state.orderWizard()?.step03);
    loggedIn = computed(() => this.step3()?.customerDto?.email != null);

    // formEmail: FormGroup = new FormGroup({
    //     email: new FormControl('', [Validators.required])
    // });

    constructor(
        public _orderWizardService: OrderWizardService,
        public _httpClient: HttpClient
        // private _translateService: TranslateService,
        // private _corpTranslateService: CorpTranslateService

    ) {
        // this.form = this._orderWizardService.formGroup;

        // console.log('this.form', this.form);
    }

    ngOnInit() {

    }

    ngOnDestroy(): void {
        this.destroy$.next()
        this.destroy$.complete()
    }

    fakeLogin() {
        const customer = new CustomerDto();
        customer.firstName = "John";
        customer.lastName = "Doe";
        customer.email = "john.doe@example.com";
        this._orderWizardService.patchCustomer(customer);
    }

    fakeLogout() {
        const customer = new CustomerDto();
        customer.firstName = null;
        this._orderWizardService.patchCustomer(customer);
    }

    
}
